"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReassignEmployeesDto = exports.ReassignEmployeesFilters = exports.EditRoleDto = exports.DeprecatedRoleDto = exports.GetRolesOptionsDto = exports.DeleteRolesOptionsDto = exports.UpdateRoleDto = exports.RoleIdsAndUserIdDto = exports.RoleIdsDto = exports.RequiredRoleIdsDto = exports.ByOrganizationIdAndRole = exports.GetRolesFiltersDto = exports.RoleDto = exports.SimpleRoleDto = exports.CreateRoleDto = exports.ByRoleIdDto = void 0;
const facilities_dto_1 = require("../../dto/facilities.dto");
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
class ByRoleIdDto extends facilities_dto_1.OptionalFacilityIdDto {
}
exports.ByRoleIdDto = ByRoleIdDto;
class CreateRoleDto extends facilities_dto_1.OptionalFacilityIdDto {
}
exports.CreateRoleDto = CreateRoleDto;
class SimpleRoleDto extends facilities_dto_1.OptionalFacilityIdDto {
}
exports.SimpleRoleDto = SimpleRoleDto;
class RoleDto extends SimpleRoleDto {
    constructor() {
        super(...arguments);
        this.permissionGroups = [];
    }
}
exports.RoleDto = RoleDto;
class GetRolesFiltersDto extends general_dto_1.PaginatedSearchDto {
    constructor() {
        super(...arguments);
        this.includeBondy = false;
        this.countUserRoles = false;
    }
}
exports.GetRolesFiltersDto = GetRolesFiltersDto;
class ByOrganizationIdAndRole extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByOrganizationIdAndRole = ByOrganizationIdAndRole;
class RequiredRoleIdsDto {
}
exports.RequiredRoleIdsDto = RequiredRoleIdsDto;
class RoleIdsDto {
}
exports.RoleIdsDto = RoleIdsDto;
class RoleIdsAndUserIdDto {
}
exports.RoleIdsAndUserIdDto = RoleIdsAndUserIdDto;
class UpdateRoleDto extends facilities_dto_1.OptionalFacilityIdDto {
}
exports.UpdateRoleDto = UpdateRoleDto;
class DeleteRolesOptionsDto extends RoleIdsDto {
    constructor() {
        super(...arguments);
        this.includeUserRoles = true;
    }
}
exports.DeleteRolesOptionsDto = DeleteRolesOptionsDto;
class GetRolesOptionsDto {
    constructor() {
        this.includeGlobalRoles = false;
        this.includePermissionGroups = false;
        this.includeNestedPermissions = false;
        this.includeUserRoles = false;
    }
}
exports.GetRolesOptionsDto = GetRolesOptionsDto;
class DeprecatedRoleDto extends RoleDto {
}
exports.DeprecatedRoleDto = DeprecatedRoleDto;
class EditRoleDto {
}
exports.EditRoleDto = EditRoleDto;
class ReassignEmployeesFilters {
}
exports.ReassignEmployeesFilters = ReassignEmployeesFilters;
class ReassignEmployeesDto {
}
exports.ReassignEmployeesDto = ReassignEmployeesDto;
//# sourceMappingURL=role.dto.js.map